<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="rccx">
      <b>供应商名称：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.name"
                placeholder="请输入供应商公司名称"/>
      <b>负责人：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.person"
                placeholder="请输入负责人"/>
      <el-button type="primary" @click="getList" size="medium" round><i class="el-icon-search"></i>查询</el-button>
      <el-button type="primary" @click="createdata" v-if="checkPrower('bzgys')" size="medium" round><i
          class="el-icon-circle-plus"></i>新建供应商
      </el-button>
      <el-button type="warning" @click="cleardata" size="medium" round><i class="el-icon-refresh"></i>重置</el-button>

    </div>

    <el-table v-loading="loading"
              :data="tableData"
              style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column

          label="公司名称"
          prop="name" align="center">
      </el-table-column>
      <el-table-column
          label="负责人"
          prop="person" align="center">
      </el-table-column>
      <el-table-column
          label="联系电话"
          prop="iphone" align="center">
      </el-table-column>

      <el-table-column
          align="center" label="操作" width="200">

        <template slot-scope="scope">
          <el-button
              size="mini"
              v-if="checkPrower('bzgys')"
              @click="handleEdit( scope.row)">
            <i class="el-icon-setting"></i>
            信息维护
          </el-button>
          <el-button
              size="mini"
              type="danger"
              v-if="checkPrower('bzgys')"
              @click="deleterole(scope.$index, scope.row)"><i class="el-icon-delete"></i>删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <template>
      <div>

        <pagination
            id="companyListpage"
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>


    <el-dialog :title="selectTable.title" :visible.sync="dialogFormVisible">
      <el-form :model="selectTable" :rules="formRules" ref="selectForm" label-width="100px">
        <el-form-item label="供应商名称:" prop="name">
          <el-input v-model="selectTable.name" auto-complete="off" placeholder="请输入供应商名称"></el-input>
        </el-form-item>

        <el-form-item label="供应商负责人:" prop="person">
          <el-input v-model="selectTable.person" auto-complete="off" placeholder="请输入供应商负责人"></el-input>
        </el-form-item>

        <el-form-item label="联系电话:" prop="iphone">
          <el-input v-model="selectTable.iphone" auto-complete="off" placeholder="请输入联系电话"></el-input>
        </el-form-item>

        <el-form-item label="标签:" label-width="100px">
          <el-tag
              v-for="tag in allTags"
              :key="tag.id"
              style="margin-left: 10px"
              :closable="true"
              :type="selectedNames.includes(tag.name) ? 'primary' : 'info'"
              @click="toggleTag(tag)"
              @close="deleteTag(tag)"
          >
            {{ tag.name }}
          </el-tag>
          <el-button @click="openTitle" style="margin-left: 10px">添加</el-button>
        </el-form-item>

        <el-form-item label="省:" prop="province">
          <el-select v-model="selectTable.province" placeholder="请选择省" @change="handleProvinceChange"
                     style="width: 100%;">
            <el-option
                v-for="item in optionsSheng"
                :key="item.id"
                :label="item.dictValue"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="市:" prop="city">
          <el-select v-model="selectTable.city" placeholder="请选择市" @change="handleCityChange" style="width: 100%;">
            <el-option
                v-for="item in optionsShi"
                :key="item.id"
                :label="item.dictValue"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="区:" prop="county">
          <el-select v-model="selectTable.county" placeholder="请选择区" style="width: 100%;">
            <el-option
                v-for="item in optionsQu"
                :key="item.id"
                :label="item.dictValue"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="详细公司地址:" prop="address">
          <el-input v-model="selectTable.address" auto-complete="off" placeholder="请输入详细公司地址"></el-input>
        </el-form-item>

        <el-form-item label="备注:" prop="remark">
          <el-input v-model="selectTable.remark" auto-complete="off" placeholder="请输入备注（选填）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createtree">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog id="titleid" title="添加标签" :visible.sync="dialogFormVisibleTitle" :close-on-click-modal="false">
      <el-form :model="TitleInfo">
        <el-form-item label="标签:" label-width="100px">
          <el-input v-model="TitleInfo.name" auto-complete="off"></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleTitle = false">取 消</el-button>
        <el-button type="primary" @click="createTitle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {
    // 自定义手机号校验
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };

// 自定义供应商名称校验
    const validateName = (rule, value, callback) => {
      if (value && (value.length < 2 || value.length > 50)) {
        callback(new Error('供应商名称长度在 2 到 50 个字符之间'));
      } else {
        callback();
      }
    };

// 自定义负责人校验
    const validatePerson = (rule, value, callback) => {
      if (value && (value.length < 2 || value.length > 20)) {
        callback(new Error('负责人姓名长度在 2 到 20 个字符之间'));
      } else {
        callback();
      }
    };

// 自定义地址校验
    const validateAddress = (rule, value, callback) => {
      if (value && value.length < 5) {
        callback(new Error('地址至少需要5个字符'));
      } else if (value && value.length > 200) {
        callback(new Error('地址不能超过200个字符'));
      } else {
        callback();
      }
    };

    return {
      formRules: {
        name: [
          {required: true, message: '供应商名称不能为空', trigger: 'blur'},
          {validator: validateName, trigger: 'blur'}
        ],
        person: [
          {required: true, message: '供应商负责人不能为空', trigger: 'blur'},
          {validator: validatePerson, trigger: 'blur'}
        ],
        iphone: [
          {required: true, message: '联系电话不能为空', trigger: 'blur'},
          {validator: validatePhone, trigger: 'blur'}
        ],
        province: [
          {required: true, message: '请选择省', trigger: 'change'}
        ],
        city: [
          {required: true, message: '请选择市', trigger: 'change'}
        ],
        county: [
          {required: true, message: '请选择区', trigger: 'change'}
        ],
        address: [
          {required: true, message: '详细地址不能为空', trigger: 'blur'},
          {validator: validateAddress, trigger: 'blur'}
        ],
        remark: [
          {max: 500, message: '备注不能超过500个字符', trigger: 'blur'}
        ]
      },
      selectedTags: [],
      dialogFormVisibleTitle: false,
      TitleInfo: {
        name: undefined,
        type: 'gys',
        state: '1',
      },
      allTags: [],
      optionsSheng: [],
      optionsShi: [],
      optionsQu: [],
      optionskhlx: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: undefined,
        person: undefined,
        status: 2,
      },
      selectTable: {
        title: '',
        id: 0,
        companyType: 2,
        status: 1,
        name: undefined,
        person: undefined,
        iphone: undefined,
        level: undefined,
        province: undefined,
        city: undefined,
        county: undefined,
      },
      defaultProps: {
        children: "children",
        label: "pname"
      },
      // 菜单列表
      menuOptions: [],
      dialogFormVisible: false,
      dialogFormData: [],
      tableData: [],
      tablelistData: [],
      search: '',
      loading: false
    }
  },
  mounted() {
    this.getList();
    this.getDic("khlx");
    this.getTitle();
  },

  methods: {
    openTitle() {
      this.TitleInfo = this.$options.data().TitleInfo
      this.dialogFormVisibleTitle = true
    },
    createTitle() {
      if (this.TitleInfo.name == null) {
        this.$message.warning('请输入标签')
        return
      }
      this.$request.postHttp({
        url: "/basic/addTitle",
        data: JSON.stringify(this.TitleInfo),
        success: (data) => {
          if (data.code == 200) {
            this.$message.success(data.msg)
            this.dialogFormVisibleTitle = false
            this.getTitle();
          } else {
            this.$message.warning(data.msg)
          }


        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    deleteTag(tag) {
      this.$request.postHttp({
        url: "/basic/delTitle",
        data: JSON.stringify(tag),
        success: (data) => {
          this.$message.success(data.msg)
          this.dialogFormVisibleTitle = false
          this.getTitle();
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    toggleTag(tag) {
      const index = this.selectedTags.findIndex(t => t.name === tag.name)
      if (index === -1) {
        this.selectedTags.push({...tag})
      } else {
        this.selectedTags.splice(index, 1)
      }
    },
    checkPrower(permission) {
      const qx = localStorage.getItem('qx');
      return qx && qx.includes(permission);
    },
    handleProvinceChange(value) {
      this.selectTable.city = null
      this.selectTable.county = null
      this.getShi()

    },
    handleCityChange() {
      this.selectTable.county = null
      this.getQu()
    },
    createtree() {
      this.$refs.selectForm.validate((valid) => {
        if (valid) {
          this.selectTable.bq = (this.selectedTags.map(tag => tag.id) ?? []).join(',')
          this.$request.postHttp({
            url: "/basic/saveInfo",
            data: JSON.stringify(this.selectTable),
            success: (data) => {
              this.$message.success(data.msg)
              this.dialogFormVisible = false
              this.getList();
            },
            error: (error) => {
              console.error("Error:", error);
              // 执行失败时的操作
            },
          })
        } else {
          this.$message.error('请完善表单信息');
          return false;
        }
      });

    },
    getDic(val) {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: val},
        success: (data) => {
          this.optionskhlx = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getSheng() {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: 'province'},
        success: (data) => {
          this.optionsSheng = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getShi() {
      this.$request.getHttp({
        url: "/system/getMap",
        params: {pid: this.selectTable.province},
        success: (data) => {
          this.optionsShi = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getQu() {
      this.$request.getHttp({
        url: "/system/getMap",
        params: {pid: this.selectTable.city},
        success: (data) => {
          this.optionsQu = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    cleardata() {
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/basic/CustomerList",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    deleterole(index, row) {
      this.$confirm('确认删除吗?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$request.postHttp({
          url: "/basic/deletegs",
          params: {rid: row.id},
          success: (data) => {
            this.$message.success('删除成功！')
            this.getList();
          },
          error: (error) => {
            this.$message.error('删除失败！')

            console.error("Error:", error);
            // 执行失败时的操作
          },
        })

      }).catch(() => {
        this.$message.info('操作已取消')
      });
    },
    createdata() {
      this.selectTable = this.$options.data().selectTable
      this.selectTable.title = '添加供应商信息'
      this.dialogFormVisible = true;
      if (this.$refs.selectForm) {
        this.$refs.selectForm.clearValidate()
      }
      this.getSheng()
    },
    handleEdit(row) {
      this.selectTable.id = row.id
      this.$request.getHttp({
        url: "/basic/getCustomerInfo",
        params: {id: this.selectTable.id},
        success: (data) => {
          this.selectTable = data.data
          this.selectTable.companyType = 2
          if (this.selectTable.id == null) {
            this.selectTable.id = 0
          }
          if (this.selectTable.id > 0) {
            this.selectTable.title = '修供应商信息'
          } else {
            this.selectTable.title = '添加供应商信息'
          }
          this.getSheng()
          if (this.selectTable.province > 0) {
            this.getShi()
          }
          if (this.selectTable.city > 0) {
            this.getQu()
          }
          if (this.$refs.selectForm) {
            this.$refs.selectForm.clearValidate()
          }
          this.dialogFormVisible = true;
          this.getselectTitle();
          console.log(this.selectTable)
        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })
    },

    getTitle() {
      this.$request.postHttp({
        url: "/basic/TitleList",
        params: {pname: 'gys'},
        success: (data) => {
          this.allTags = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getselectTitle() {
      if (!this.selectTable.bq || this.selectTable.bq.trim() === '') {
        this.selectedTags = [];
        return;
      }
      const idArray = this.selectTable.bq.split(',').map(id => parseInt(id, 10));
// 从allTags中筛选出对应的标签
      this.selectedTags = this.allTags.filter(tag => idArray.includes(tag.id));
    }
  },
  computed: {
    selectedNames() {
      return this.selectedTags.map(t => t.name)
    }
  }
}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

selectupwidth el-select {
  width: 120px;
}

/*#roleListpage .el-pager li.active {
  color: white;
}*/
</style>